



















import Vue from 'vue'
import { mapGetters } from 'vuex'

import { bus } from './main'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default Vue.extend({
  name: 'App',
  data() {
    return {
      loginDialog: false as boolean
    }
  },
  computed: {
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
      dealerLoading: 'dealers/loading',
      currentMake: 'makes/currentMake'
    })
  },
  created() {
    this.initialSetup()
  },
  mounted() {
    bus.$on('sessionTimeout', this.openDialog)
  },
  methods: {
    async initialSetup() {
      const makeId = this.$route.params.makeId
      const dealerCode = this.$route.params.dealerCode
      if (this.currentMake.id != makeId || (this.currentMake.id == makeId && this.currentDealer.code != dealerCode)) {
        this.$store.commit('cart/clearCart')
        this.$store.commit('trims/clearCurrentTrim')
        this.$store.commit('models/clearCurrentModel')
        this.$store.commit('trims/clearTrims')
        this.$store.dispatch('auth/signOut')
      }
      await this.$store.dispatch('dealers/loadDealer', { makeId: makeId, dealerCode: dealerCode })
      if (this.currentDealer.hst > 0) {
        this.$store.commit('cart/setTaxRate', this.currentDealer.hst)
      } else {
        this.$store.commit('cart/setTaxRate', this.currentDealer.gst + this.currentDealer.pst)
      }
      await this.$store.dispatch('makes/loadMake', { makeId: makeId })
      await this.$store.dispatch('models/reloadCarouselModels', { makeId: makeId })
      await this.$store.dispatch('years/reloadYears', { makeId: makeId })
    },
    openDialog() : void {
      this.loginDialog = true
      this.$store.dispatch('auth/clearAuth')
    },
    goToLogin(): void {
      this.loginDialog = false
      this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/login')
    }
  },
  components: {
    Header,
    Footer
  }
})
